export default {
  path: '/digital',
  name: 'digital',
  meta: { title: '营销数字人' },
  children: [
    {
      path: '/digital/:type',
      name: 'digitalIndex',
      component: () => import('@/views/digital/index.vue'),
      meta: { title: '营销数字人', subTitle: '品牌专属 IP，7x24h 持续输出内容', key: 'digital' },
    },
  ],
};
